/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import { connect } from 'react-redux';
import { setLang } from './redux/actions';

import { I18n } from '@aws-amplify/core';

/*
 * Load SignInContainer for SingIn/SingUp
 */
import SignInContainer from './components/LandingPage/signInContainer';

/*
 * Load i18n Localization
 */
const lang = navigator.languages[0];
try {
	const configTranslations = {};

	const sanitizedLang = lang.split("-")[0];
	console.debug(sanitizedLang)
	const translationModule = await import(
		`./translations/${sanitizedLang}.json`
	);
	configTranslations[sanitizedLang] = translationModule.default.widget;
	I18n.putVocabularies(configTranslations);

} catch (error) {
	console.warn(`No translation file for ${lang}`);
}
/*
 * Load Default Language
 * Set i18n Localization
 * Check Browser Language: If it exists in /translations/{lang}.json then use the Browser Language, else use default "en"
 */
const setLanguage = async () => {
	const lang = navigator.languages[0];
	try {
		I18n.setLanguage(lang);
		return lang;
	} catch (error) {
		console.warn(`No translation file for ${lang}`);
		I18n.setLanguage("en");
		return "en";
	}

}

/*
 * Map lang state to p
 */
const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
	}
}

class App extends React.Component {
	constructor(props) {
		super(props);

		this.props.setLang(setLanguage());

		this.state = {};
	}

	render() {
		return (
			<div>
				<SignInContainer />
			</div>
		);
	}
}

export default connect(mapStateToProps, { setLang })(App);
